
import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Phone,
  MapPin,
  Mail,
  ArrowUpRight,
} from "lucide-react";
import "./Footer.css";
import logo from "../assets/logo6.png";

const QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Our Service", to: "/services" },
  { label: "Gallery", to: "/gallery" },
  { label: "Review", to: "/review" },
  { label: "Contact", to: "/contact" },
];

const DESTINATION_LINKS = [
  {
    label: "Statue of Unity",
    to: "/destinations/statue-of-unity",
  },
  {
    label: "Pavagadh",
    to: "/destinations/pavagadh",
  },
  {
    label: "Poicha",
    to: "/destinations/poicha",
  },
  {
    label: "Dakor",
    to: "/destinations/dakor",
  },
  {
    label: "Kavi Kamboi Mahadev Mandir",
    to: "/destinations/kavi-kamboi-mahadev-mandir",
  },
];

export default function Footer({
  brandName = "Bhole Cab Service",
  phone = "+91 7574098964",
  address = "Vadodara, Gujarat 390025",
  email = "info@bholecabservices.com",
}) {
  const location = useLocation();
  const year = new Date().getFullYear();

  const isActiveLink = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }

    return (
      location.pathname === path ||
      location.pathname.startsWith(`${path}/`)
    );
  };

  const getLinkClass = (path) =>
    isActiveLink(path) ? "footer-link-active" : "";

  const phoneHref = `tel:${phone.replace(/[^\d+]/g, "")}`;

  return (
    <footer className="site-footer">
      <div className="footer-inner">
        {/* Brand */}
        <div className="footer-col footer-brand">
          <Link
            to="/"
            className="footer-brand-wrapper"
            aria-label={`${brandName} home`}
          >
            <img
              src={logo}
              alt={brandName}
              className="footer-logo"
              loading="lazy"
            />
          </Link>

          <p className="footer-brand-description">
            Reliable, comfortable rides across Vadodara — anytime
            you need one. Book your cab today and experience
            comfortable travel for local and outstation journeys.
          </p>

          <a href={phoneHref} className="footer-call-button">
            <Phone size={17} />
            <span>Call for Booking</span>
            <ArrowUpRight size={16} />
          </a>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h4>Quick Links</h4>

          <ul className="footer-link-list">
            {QUICK_LINKS.map((link) => {
              const active = isActiveLink(link.to);

              return (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className={getLinkClass(link.to)}
                    aria-current={active ? "page" : undefined}
                  >
                    {link.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Popular Destinations */}
        <div className="footer-col footer-destinations">
          <h4>Popular Destinations</h4>

          <ul className="footer-link-list">
            {DESTINATION_LINKS.map((place) => {
              const active = isActiveLink(place.to);

              return (
                <li key={place.to}>
                  <Link
                    to={place.to}
                    className={getLinkClass(place.to)}
                    aria-current={active ? "page" : undefined}
                  >
                    {place.label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-col footer-contact-column">
          <h4>Get In Touch</h4>

          <ul className="footer-contact">
            <li>
              <Phone size={18} aria-hidden="true" />
              <div>
                <span className="footer-contact-label">
                  Call for bookings
                </span>
                <a href={phoneHref}>{phone}</a>
              </div>
            </li>

            <li>
              <Mail size={18} aria-hidden="true" />
              <div>
                <span className="footer-contact-label">
                  Email us
                </span>
                <a href={`mailto:${email}`}>{email}</a>
              </div>
            </li>

            <li>
              <MapPin size={18} aria-hidden="true" />
              <div>
                <span className="footer-contact-label">
                  Our location
                </span>
                <span className="footer-contact-address">
                  {address}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>

      {/* Compact Bottom Bar */}
      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p>
            © {year} <span>{brandName}</span>. All rights reserved.
          </p>

          {/* <Link to="/contact" className="footer-bottom-link">
            Plan your next trip
            <ArrowUpRight size={14} />
          </Link> */}
        </div>
      </div>
    </footer>
  );
}
